import React from "react";
import { motion } from "framer-motion";
import "./Loader.scss";

const Loader = ({ message = "Loading..." }) => {
  return (
    <>
      <div className="page-loader-overlay">
        <motion.div
          className="loader-content"
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="visual-hub">
            <div className="outer-ring" />
            <div className="middle-ring" />
            <div className="data-particle p1" />
            <div className="data-particle p2" />
            <div className="core-node">
              {/* AI Relatable Brain-Circuit SVG */}
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path
                  d="M9.5 2A2.5 2.5 0 0 1 12 4.5v15a2.5 2.5 0 0 1-4.96.44 2.5 2.5 0 0 1-2.96-3.08 3 3 0 0 1-.34-5.58 2.5 2.5 0 0 1 1.32-4.24 2.5 2.5 0 0 1 4.44-1.54Z"
                  fill="rgba(255,255,255,0.1)"
                />
                <path
                  d="M14.5 2A2.5 2.5 0 0 0 12 4.5v15a2.5 2.5 0 0 0 4.96.44 2.5 2.5 0 0 0 2.96-3.08 3 3 0 0 0 .34-5.58 2.5 2.5 0 0 0-1.32-4.24 2.5 2.5 0 0 0-4.44-1.54Z"
                  fill="rgba(255,255,255,0.1)"
                />
                <path d="M12 5v14" opacity="0.5" />
                <circle cx="12" cy="12" r="1" fill="currentColor" />
                <path
                  d="M7 8h.01M17 8h.01M7 16h.01M17 16h.01"
                  strokeWidth="3"
                />
              </svg>
            </div>
          </div>

          <div className="loader-status">
            <p className="status-text">{message}</p>
          </div>
        </motion.div>
      </div>
    </>
  );
};

export default Loader;
